import React, { useEffect, useRef } from 'react'
import { RenderDropdown } from './dropdown';
import swal from 'sweetalert';


export const CustomRenderBox = ({
    Boxes,
    setBoxes,
    areaProps,
    fieldsExtracted,
    tablesExtracted,
    PageNo,
    refList,
    Lables,
    setchangeDetect,
    setchangeAdd,
    DocLockedForMe,
    RulesFromServer,
    setchangePage,
    selectedEntity,
	setselectedEntity,
    newSelectedEntity
}) => {
    

    const lableEl = useRef(null)


    const myEntity = useRef(areaProps?.entity?.toLowerCase() || '');

    function DeletePop(areaNum) {
        swal('Are you sure you want to Delete?', {
            buttons: ['No', 'Yes'],
        }).then((value) => {
            if (value) {
                // User clicked "Yes" button
                let deleteIndex = areaNum - 1;

                let allTags = [...Boxes];
                if (deleteIndex !== -1) {
                    //   let flds = { ...fieldsExtracted }
                    //   delete flds[allTags[deleteIndex]['entity']]
                    allTags.splice(deleteIndex, 1);
                    //   setfieldsExtracted(flds)
                    setBoxes(allTags);
                    if (DocLockedForMe){
                        setchangeDetect(true)
                        setchangeAdd(p=> p+1)
                        setchangePage(p=> {
                            return {
                                ...p,
                                [PageNo]: true
                            }
                        })

                    }
                }

            }
        });
        setselectedEntity('');
    }

    useEffect(() => {
        function handleClass() {
            refList.current.map(itm => {
                itm.current.classList.remove("clicked")
                itm.current.style.zIndex = 2 
                return null
            }
            )
            lableEl.current.classList.add("clicked")
            lableEl.current.style.zIndex = 3
            
            newSelectedEntity.current = myEntity.current?.toLowerCase()
            
        }

        if (lableEl.current) {
            refList.current.push(lableEl)
            var node = lableEl.current.parentNode
            // handleClass()
            node.addEventListener('click', handleClass);

        }
    let observerRefValue = refList?.current
    
      return () => {
        if (observerRefValue) {
            observerRefValue.splice(observerRefValue.indexOf(lableEl))
            node?.removeEventListener('click', handleClass);
        }
           
      }
    }, [])

    useEffect(() => {
        if (newSelectedEntity.current === '') {
            return;
        }
        
        if (newSelectedEntity.current?.toLowerCase() !== selectedEntity?.toLowerCase()) {
            setselectedEntity(newSelectedEntity.current)
            newSelectedEntity.current = ''
        }
    }, [newSelectedEntity.current])

    useEffect(() => {
        
        if (lableEl.current && selectedEntity?.toLowerCase() === areaProps?.entity?.toLowerCase()) {
            
            lableEl.current.classList.add("clicked")
        }
        else{
            lableEl.current.classList.remove("clicked")
        }
    }, [selectedEntity])

    useEffect(() => {
        
      if (lableEl.current){
        if (!RulesFromServer.map(itm => itm?.entity_name?.toLowerCase()).includes(areaProps?.entity?.toLowerCase()) ) {
            let node = lableEl.current.parentNode
            node.classList.add("noLable")
        }
        else{
            let node = lableEl.current.parentNode
            node.classList.remove("noLable")
        }
    }
    
    }, [areaProps?.entity, RulesFromServer])

    useEffect(() => {

        myEntity.current = areaProps?.entity?.toLowerCase() || '';
    }, [areaProps?.entity])
    
    

    return (
        <div ref={lableEl} className="areaBoxOuter" key={areaProps.areaNumber}>
            <button
                type="button"
                className="delBBBtn"
                onClick={() => DeletePop(areaProps.areaNumber)}
            >
                &times;
            </button>
            <RenderDropdown
                    Boxes={Boxes}
                    setBoxes={setBoxes}
                    areaProps={areaProps}
                    fieldsExtracted={fieldsExtracted}
                    tablesExtracted={tablesExtracted}
                    PageNo={PageNo}
                    Lables={Lables}
                    setchangeDetect={setchangeDetect}
                    setchangeAdd={setchangeAdd}
                    DocLockedForMe={DocLockedForMe}
                    RulesFromServer={RulesFromServer}
                    setchangePage={setchangePage}
                />
            
        </div>
    )
}